import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment  } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class PromotionService {
  mainURL = 'api/promotion/';
  constructor(private http: HttpClient) { }
validatePromo(code: string, referenceType: string, userId?: string): Observable<any> {
    const token = localStorage.getItem('token');
    
    const options = token 
        ? { headers: { 'Authorization': `Bearer ${token}` } }
        : {};
    
    return this.http.post(
        `${environment.apiUrl}api/promotion/validate`, 
        {
            code,
            referenceType,
            userId
        },
        options
    );
}
  usePromotionCode(promotionCode: string) {
    return this.http.post(environment.apiUrl + this.mainURL + 'usepromotion', promotionCode);
  }
}
